import React, { useEffect, useState } from 'react';
import { Container, Box, useColorModeValue } from '@chakra-ui/react';
import TokenConfigForm from '../components/TokenConfigForm';
import ConnectWallet from '../components/ConnectWallet';
import { useWeb3 } from '../lib/Web3Provider';
import { useSearchParams } from 'react-router-dom';

const ConfigurePage: React.FC = () => {
  const { connected } = useWeb3();
  const [searchParams] = useSearchParams();
  const [tokenId, setTokenId] = useState<string>('');
  const bgColor = useColorModeValue('white', 'gray.800');

  useEffect(() => {
    // Check if there's a tokenId in the URL parameters
    const paramTokenId = searchParams.get('tokenId');
    if (paramTokenId) {
      setTokenId(paramTokenId);
    }
  }, [searchParams]);

  if (!connected) {
    return <ConnectWallet />;
  }

  return (
    <Container maxW="container.lg" py={8}>
      <Box 
        bg={bgColor}
        p={8} 
        borderRadius="lg" 
        boxShadow="md"
      >
        <TokenConfigForm initialTokenId={tokenId} />
      </Box>
    </Container>
  );
};

export default ConfigurePage;